export const getZone = async ({
    bearer,
    admin_unit,
}: {
    bearer: string;
    admin_unit: string;
}) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/child-admin-units/?admin_unit_uuid=${admin_unit}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log("zone: ", response);
        console.log("admin_unit: ", admin_unit);
        throw new Error("Failed to get zones requests");
    }
    return response.json();
};

export const getWoreda = async ({
    bearer,
    admin_unit,
}: {
    bearer: string;
    admin_unit: string;
}) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness/woreda-by-zone/?admin_unit_uuid=${admin_unit}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log("woreda: ", response);
        console.log("admin_unit: ", admin_unit);
        throw new Error("Failed to get woredas requests");
    }
    return response.json();
};

export const getEmployeesByAdminAndOrg = async ({
    bearer,
    admin_unit,
    org_unit,
}: {
    bearer: string;
    admin_unit: string;
    org_unit?: string;
}) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL_1}user-management/prosecutor-list/fetch_employees_by_admin_unit_org_org/?admin_id=${admin_unit}&org_id=${org_unit}`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log("response: ", response);
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const getStakeholdersLocal = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}external_user_mang/stakeholders/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
    }
    return response.json();
};

export const getStakeholderLocal = async (id: string, bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}external_user_mang/stakeholders/${id}/`,
        {
            headers: {
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
    }
    return response.json();
};

export const getStakeholders = async (bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL_3}client_managements/clients/`,
        {
            headers: {
                Authorization: `Bearer ${bearer}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
    }
    return response.json();
};

export const getStakeholder = async (id: string, bearer: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL_3}client_managements/clients/${id}/`,
        {
            headers: {
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        console.log(response);
    }
    return response.json();
};

export const getStakeholderUsers = async () => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}external_user_mang/stakeholder-users/`,
        {
            headers: {
                "Content-Type": "application/json",
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        throw new Error("Failed to get legal research requests");
    }
    return response.json();
};

export const getStakeholderUsersId = async (id: string) => {
    try {
        const response = await getStakeholderUsers();
        const filtered = response.filter((data: any) => data.stakeholder.id === id);
        console.log("filtered: ", filtered);
        return filtered;
    } catch (error) {
        console.error(error);
        throw new Error("Failed to get Stakeholder Users");
    }
};

export const createStakeholder = async (data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}external_user_mang/stakeholders/`,
        {
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create stakeholder");
    }
    return response.json();
};

export const createStakeholderUser = async (data: FormData) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}external_user_mang/stakeholder-users/`,
        {
            method: "POST",
            body: data,
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create stakeholder");
    }
    return response.json();
};
